export default "__VITE_ASSET__CH0Tr4hE__"